import CityHall from "@/roc/building/home/CityHall";
import SmallHome from "@/roc/building/home/SmallHome";
import AverageHome from "@/roc/building/home/AverageHome";
import LuxuriousHome from "@/roc/building/home/LuxuriousHome";
import RuralFarm from "@/roc/building/farm/RuralFarm";
import DomesticFarm from "@/roc/building/farm/DomesticFarm";
import LuxuriousFarm from "@/roc/building/farm/LuxuriousFarm";
import InfantryBarracks from "@/roc/building/barracks/InfantryBarracks";
import RangedBarracks from "@/roc/building/barracks/RangedBarracks";
import CavalryBarracks from "@/roc/building/barracks/CavalryBarracks";
import HeavyInfantryBarracks from "@/roc/building/barracks/HeavyInfantryBarracks";
import SiegeBarracks from "@/roc/building/barracks/SiegeBarracks";
import Artisan from "@/roc/building/workshop/Artisan";
import StoneMason from "@/roc/building/workshop/StoneMason";
import Tailor from "@/roc/building/workshop/Tailor";
import Scribe from "@/roc/building/workshop/Scribe";
import Carpenter from "@/roc/building/workshop/Carpenter";
import SpiceMerchant from "@/roc/building/workshop/SpiceMerchant";
import LittleCultureSite from "@/roc/building/culture/LittleCultureSite";
import CompactCultureSite from "@/roc/building/culture/CompactCultureSite";
import ModerateCultureSite from "@/roc/building/culture/ModerateCultureSite";
import LargeCultureSite from "@/roc/building/culture/LargeCultureSite";
import LuxuriousCultureSite from "@/roc/building/culture/LuxuriousCultureSite";
import School from "@/roc/building/collectable/School";
import MinoanWatchtower from "@/roc/building/collectable/MinoanWatchtower";
import ArchitectStudio from "@/roc/building/collectable/ArchitectStudio";
import PirateFortress from "@/roc/building/event/PirateFortress";
import HydraMonument from "@/roc/building/event/HydraMonument";
import MadScientistsLab from "@/roc/building/event/MadScientistsLab";
import WinterMarket from "@/roc/building/event/WinterMarket";
import TrojanHorse from "@/roc/building/event/TrojanHorse";
import CelticBroch from "@/roc/building/event/CelticBroch";
import PersianPalace from "@/roc/building/event/PersianPalace";
import YurtOfTheKhan from "@/roc/building/event/YurtOfTheKhan";
import Madrasa from "@/roc/building/event/Madrasa";
import ShrineOfReflection from "@/roc/building/event/ShrineOfReflection";
import CryptOfTheCount from "@/roc/building/event/CryptOfTheCount";
import CommanderTower from "@/roc/building/collectable/CommanderTower";
import GreatGarden from "@/roc/building/event/GreatGarden";
import WinterBakery from "@/roc/building/event/WinterBakery";
import DruidGrove from "@/roc/building/event/DruidGrove";
import MongolianFeast from "@/roc/building/event/MongolianFeast";
import ElysianField from "@/roc/building/event/ElysianField";
import MosaicBath from "@/roc/building/event/MosaicBath";
import DovecoteTower from "@/roc/building/event/DovecoteTower";
import Exhibition from "@/roc/building/event/Exhibition";
import FountainOfYouth from "@/roc/building/event/FountainOfYouth";
import DrumTower from "@/roc/building/event/DrumTower";
import TreasureWreck from "@/roc/building/event/TreasureWreck";
import HotAirBalloon from "@/roc/building/event/HotAirBalloon";
import GrandSmithy from "@/roc/building/event/GrandSmithy";
import MongolianMotherTree from "@/roc/building/event/MongolianMotherTree";
import VictorianConservatory from "@/roc/building/event/VictorianConservatory";
import AncientLibrary from "@/roc/building/event/AncientLibrary";
import Amphitheatre from "@/roc/building/collectable/Amphitheatre";
import Woodhenge from "@/roc/building/collectable/Woodhenge";
import MongolianSaddler from "@/roc/building/collectable/MongolianSaddler";
import Astronomer from "@/roc/building/collectable/Astronomer";
import BirdHouse from "@/roc/building/collectable/BirdHouse";
import ArcGate from "@/roc/building/collectable/ArcGate";
import TikiStatue from "@/roc/building/collectable/TikiStatue";
import BasketDryingRack from "@/roc/building/collectable/BasketDryingRack";
import ShirazWineHouse from "@/roc/building/event/ShirazWineHouse";
import GriotCourt from "@/roc/building/event/GriotCourt";
import SacredMarae from "@/roc/building/event/SacredMarae";
import TempleGate from "@/roc/building/collectable/TempleGate";
import AirshipExhibit from "@/roc/building/collectable/AirshipExhibit";
import NaturalHistoryMuseum from "@/roc/building/event/NaturalHistoryMuseum";
import AztecMainTemple from "@/roc/building/event/AztecMainTemple";
import Jeweler from "@/roc/building/workshop/Jeweler";
import Alchemist from "@/roc/building/workshop/Alchemist";
import Glassblower from "@/roc/building/workshop/Glassblower";
import DraculasCastle from "@/roc/building/event/DraculasCastle";
import MidnightClock from "@/roc/building/collectable/MidnightClock";
import BanyanTree from "@/roc/building/collectable/BanyanTree";
import RoyalTemple from '@/roc/building/event/RoyalTemple';
import WinterPavilion from '@/roc/building/collectable/WinterPavilion';
import SleighStation from '@/roc/building/event/SleighStation';
import CelticArch from '@/roc/building/event/CelticArch';
import TravelingYurt from '@/roc/building/event/TravelingYurt';
import QuintennialMonument from '@/roc/building/collectable/QuintennialMonument';
import TheAqueduct from "@/roc/building/event/TheAqueduct";
import GateOfAllNations from "@/roc/building/event/GateOfAllNations";
import ShintoShrine from "@/roc/building/event/ShintoShrine";
import LakePagoda from "@/roc/building/collectable/LakePagoda";
import MansasTreasury from "@/roc/building/event/MansasTreasury";
import PalaceOfFineArts from "@/roc/building/event/PalaceOfFineArts";
const Buildings = [
    CityHall,
    SmallHome,
    AverageHome,
    LuxuriousHome,
    RuralFarm,
    DomesticFarm,
    LuxuriousFarm,
    InfantryBarracks,
    RangedBarracks,
    CavalryBarracks,
    HeavyInfantryBarracks,
    SiegeBarracks,
    Artisan,
    StoneMason,
    Tailor,
    Scribe,
    Carpenter,
    SpiceMerchant,
    LittleCultureSite,
    CompactCultureSite,
    ModerateCultureSite,
    LargeCultureSite,
    LuxuriousCultureSite,
    School,
    MinoanWatchtower,
    ArchitectStudio,
    PirateFortress,
    HydraMonument,
    MadScientistsLab,
    WinterMarket,
    TrojanHorse,
    CelticBroch,
    PersianPalace,
    YurtOfTheKhan,
    Madrasa,
    ShrineOfReflection,
    CryptOfTheCount,
    CommanderTower,
    GreatGarden,
    WinterBakery,
    DruidGrove,
    MongolianFeast,
    ElysianField,
    MosaicBath,
    DovecoteTower,
    Exhibition,
    FountainOfYouth,
    DrumTower,
    TreasureWreck,
    HotAirBalloon,
    GrandSmithy,
    MongolianMotherTree,
    VictorianConservatory,
    AncientLibrary,
    Amphitheatre,
    Woodhenge,
    MongolianSaddler,
    Astronomer,
    BirdHouse,
    ArcGate,
    BasketDryingRack,
    TikiStatue,
    ShirazWineHouse,
    GriotCourt,
    SacredMarae,
    AirshipExhibit,
    TempleGate,
    NaturalHistoryMuseum,
    AztecMainTemple,
    Jeweler,
    Alchemist,
    Glassblower,
    DraculasCastle,
    MidnightClock,
    BanyanTree,
    RoyalTemple,
    WinterPavilion,
    SleighStation,
    CelticArch,
    TravelingYurt,
    QuintennialMonument,
    TheAqueduct,
    GateOfAllNations,
    ShintoShrine,
    LakePagoda,
    MansasTreasury,
    PalaceOfFineArts,
];
export default Buildings;
